import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { JupiterInspectionInfo } from '../types/jupiter-inspection-info.type';

@Pipe({
  name: 'inspectionTitle',
  pure: false,
})
export class InspectionTitlePipe implements PipeTransform, OnDestroy {
  private subscription: Subscription;

  constructor(cdr: ChangeDetectorRef, private readonly translate: TranslateService) {
    this.subscription = translate.onLangChange.subscribe(() => cdr.markForCheck());
  }

  transform(inspectionInfo: JupiterInspectionInfo): string {
    const value = inspectionInfo.title.trim();
    const translationKey = `JUPITER.${value}`;
    const translated = this.translate.instant(translationKey);

    return translated === translationKey ? value : translated;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
